import { useEffect, useState } from 'react';
import "./GenericSelect.css";
import { set } from 'react-datepicker/dist/date_utils';

export type GenericSelectOption = {
    displayName: string;
    value: any;
    image?: string;
}

type GenericSelectProps = {
    selected?: GenericSelectOption;
    options: GenericSelectOption[];
    onChange: (value: any) => void;
    isFont?: boolean;
    maxHeight?: string;
}

export const GenericSelect = ({ selected, options, onChange, isFont = false, maxHeight, ...rest }: GenericSelectProps) => {

	const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {

        // get rid of the clickout event handler if needed
        return () => {
            document.removeEventListener('keydown', eventKeyDown, true);
        }
    }, []);

    const handleClick = (e: any) => {
        // if it is now going to be open
        if (!isOpen) {
            document.addEventListener('keydown', eventKeyDown, true);
        }

        setIsOpen(!isOpen);
    }

    const eventKeyDown = (e: any) => {
        if (e.key === 'Escape') {
            e.stopPropagation();
            setIsOpen(false);
        }
    }

    return (
		<div className="generic-select-container">
            <div 
                className="generic-select"
                onClick={handleClick}
                style={{
                    ...(isOpen ? {zIndex: 101} :{}),
                    ...(maxHeight ? {maxHeight: maxHeight} : {})
                    }}
            >
                <div 
                    className="generic-select-selected"
                    style={isFont ? {fontFamily: selected?.value} : {}}
                >
					{selected && selected.image && 
                        <img src={selected.image} />
                    }
					{selected && selected.displayName}
                </div>

                {isOpen &&
                    <div className="generic-select-options">
                        {options.map((option: GenericSelectOption) => {
                            return (				
                                <div 
                                    key={option.value}
                                    className="generic-select-option"
                                    onClick={() => {
                                        onChange(option.value);
                                        setIsOpen(false);
                                    }}
                                    style={isFont ? {fontFamily: option.value} : {}}
                                >
									{option.image && 
                                        <img src={option.image} />
                                    }
									{option.displayName}
                                </div>
                            )
                        }
                        )}
                    </div>
                }

            </div>
        </div>
    )
}
